import { createContext, Dispatch, SetStateAction, useContext } from "react";

export type TeacherContextState = {
  canInviteAllParents: boolean;
  hasSentInviteBefore: boolean;
};

export type TeacherContextValue = {
  state: TeacherContextState;
  setState: Dispatch<SetStateAction<TeacherContextState>>;
};

export const defaultTeacherContextState: TeacherContextState = {
  canInviteAllParents: true,
  hasSentInviteBefore: false
};

export const defaultTeacherContextValue: TeacherContextValue = {
  state: defaultTeacherContextState,
  setState: () => {}
};

export const TeacherContext = createContext<TeacherContextValue>(
  defaultTeacherContextValue
);

export function useTeacherContext() {
  return useContext(TeacherContext);
}
